import { cn } from "@/lib/utils";
import type { HTMLAttributes } from "react";

export default function Skeleton({
  className,
  ...props
}: HTMLAttributes<HTMLElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-background-neutral-hovered", className)}
      aria-busy="true"
      aria-label="Loading"
      {...props}
    />
  );
}
